export const HowItWorksBlock = () => {
    return <section className="section s-hiw">
    <div className="inside-wrapper">
        <h2 className="section__title">
            How does this work?
        </h2>
        <ul className="s-hiw__list">
            <li className="s-hiw__item">
                <figure className="s-hiw__fig">
                    <picture className="s-hiw__pic">
                        <img className="s-hiw__img" src="./img/hiw01.svg" alt="" width="300" height="226"/>
                    </picture>
                    <figcaption className="s-hiw__caption">
                        Choose video templates
                    </figcaption>
                </figure>
            </li>
            <li className="s-hiw__item">
                <figure className="s-hiw__fig">
                    <picture className="s-hiw__pic">
                        <img className="s-hiw__img" src="./img/hiw02.svg" alt="" width="300" height="226"/>
                    </picture>
                    <figcaption className="s-hiw__caption">
                        Upload your photos
                    </figcaption>
                </figure>
            </li>
            <li className="s-hiw__item">
                <figure className="s-hiw__fig">
                    <picture className="s-hiw__pic">
                        <img className="s-hiw__img" src="./img/hiw03.svg" alt="" width="300" height="226"/>
                    </picture>
                    <figcaption className="s-hiw__caption">
                        Download your video
                    </figcaption>
                </figure>
            </li>
        </ul>
    </div>
</section>
}

export default HowItWorksBlock;